import React from 'react';

import RefinancedContracts from '~/screens/ContractDetails/Panels/RefinancedContracts';

import { ContractSubViewHeader } from '../components/ContractSubViewHeader';

type ContractRefinancedViewProps = {
  contractId: string;
  onBack: () => void;
};

export function ContractRefinancedView({ contractId, onBack }: ContractRefinancedViewProps) {
  return (
    <div>
      <ContractSubViewHeader contractId={contractId} onBack={onBack} />
      <RefinancedContracts contractId={contractId} />
    </div>
  );
}
